
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsionRudder as ObiPropulsionRudderElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion-rudder.js';
 
 
 

 
 export const ObiPropulsionRudder = createComponent({
   react: React,
   tagName: 'obi-propulsion-rudder',
   elementClass: ObiPropulsionRudderElement,
   events: {
     
   }
  });
 
 